import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Chip } from "primereact/chip";
import { useEffect, useState } from "react";

export default function DadosConsultaPJ({
  dadosConsultaPJ,
  capitalSocial,
  isConsultaNova,
}: {
  dadosConsultaPJ: any;
  capitalSocial: string;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();
  const [cnaeSecundario, setCnaeSecundario] = useState<string>();
  const [filiais, setFiliais] = useState<string>();

  useEffect(() => {
    if (dadosConsultaPJ.cnaeSecundario) {
      let result = '';
      dadosConsultaPJ.cnaeSecundario.map((opcao: string) => {
        if (result.length == 0) {
          result = result.concat(opcao);
        } else {
          result = result.concat(', ').concat(opcao);
        }
      });
      setCnaeSecundario(result);
    }
    if (dadosConsultaPJ.filiaisRegiao) {
      let resultFiliais = '';
      dadosConsultaPJ.filiaisRegiao.map((opcao: string) => {
        if (resultFiliais.length == 0) {
          resultFiliais = resultFiliais.concat(opcao);
        } else {
          resultFiliais = resultFiliais.concat(', ').concat(opcao);
        }
      });
      setFiliais(resultFiliais);
    }
  }, []);

  if (isConsultaNova) {
    const situacao = dadosConsultaPJ.situacao || '';
    const isAtivo = situacao.toUpperCase() === 'ATIVO';

    const InfoField = ({ label, value, accent }: { label: string; value: string; accent?: boolean }) => (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <span
          style={{
            fontSize: '0.7rem',
            fontWeight: 700,
            color: '#9CA3AF',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
          }}
        >
          {label}
        </span>
        <span
          style={{
            fontWeight: accent ? 700 : 500,
            color: accent ? '#1E3A8A' : '#374151',
            fontSize: 'small',
            wordBreak: 'break-word',
          }}
        >
          {value || 'Não Informado'}
        </span>
      </div>
    );

    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            marginBottom: '24px',
            borderBottom: '1px solid #F3F4F6',
            paddingBottom: '16px',
          }}
        >
          <div
            style={{
              backgroundColor: '#EFF6FF',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i className="pi pi-building" style={{ color: '#2563EB', fontSize: '24px' }}></i>
          </div>
          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: '1.1rem', fontWeight: 700, margin: '0 0 4px 0', color: '#1E3A8A' }}>
              {dadosConsultaPJ.razaoSocial || 'Razão Social não informada'}
            </h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
              <span style={{ fontSize: 'small', color: '#6B7280', fontWeight: 500 }}>
                {dadosConsultaPJ.documento}
              </span>
              {dadosConsultaPJ.nomeFantasia && (
                <span style={{ fontSize: '0.75rem', color: '#9CA3AF' }}>· {dadosConsultaPJ.nomeFantasia}</span>
              )}
            </div>
          </div>
          <span
            style={{
              backgroundColor: isAtivo ? '#DEF7EC' : '#FDE8E8',
              color: isAtivo ? '#03543F' : '#9B1C1C',
              fontWeight: 700,
              fontSize: '0.75rem',
              padding: '4px 12px',
              borderRadius: '20px',
              border: `1px solid ${isAtivo ? '#84E1BC' : '#F8B4B4'}`,
              whiteSpace: 'nowrap',
            }}
          >
            {situacao || 'Não Informado'}
          </span>
        </div>

        {/* Primary data grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '20px',
            marginBottom: '20px',
          }}
        >
          <InfoField label="CNAE" value={dadosConsultaPJ.cnae} />
          <InfoField label={t('dataAbertura')} value={dadosConsultaPJ.dataAbertura} />
          <InfoField label={t('fone')} value={dadosConsultaPJ.telefone} />
          <InfoField label={t('email')} value={dadosConsultaPJ.email} />
          <InfoField label={t('capitalSocial')} value={capitalSocial} accent />
          <InfoField label={t('nire')} value={dadosConsultaPJ.nire} />
          <InfoField label={t('naturezaJuridica')} value={dadosConsultaPJ.naturezaJuridica} />
          <InfoField label={t('porte')} value={dadosConsultaPJ.porte} />
          <InfoField label={t('colaboradores')} value={dadosConsultaPJ.quantidadeColaboradores} />
          <InfoField label={t('filiais')} value={dadosConsultaPJ.quantidadeFiliais} />
          <InfoField label={t('tipo')} value={dadosConsultaPJ.tipo} />
          {cnaeSecundario && <InfoField label={`${t('cnae')} Secundário`} value={cnaeSecundario} />}
          {filiais && <InfoField label={t('filiaisRegiao')} value={filiais} />}
        </div>

        {/* Address footer */}
        {dadosConsultaPJ.endereco && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: '#F9FAFB',
              border: '1px solid #E5E7EB',
              borderRadius: '12px',
              padding: '12px 18px',
              flexWrap: 'wrap',
              gap: '12px',
              marginBottom: '20px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <i className="pi pi-map-marker" style={{ color: '#3B82F6', fontSize: '16px' }}></i>
              <span style={{ fontSize: 'small', fontWeight: 600, color: '#4B5563' }}>
                {dadosConsultaPJ.endereco}
              </span>
            </div>
          </div>
        )}

        {/* Google Maps embed */}
        {dadosConsultaPJ.endereco && (
          <div style={{ marginBottom: '8px' }}>
            <label
              style={{
                display: 'block',
                fontSize: '0.7rem',
                fontWeight: 700,
                color: '#9CA3AF',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                marginBottom: '8px',
              }}
            >
              Localização no Mapa
            </label>
            <iframe
              className="no-print"
              title="Mapa do Endereço"
              width="100%"
              height="280"
              style={{ border: 0, borderRadius: '12px' }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0&q=${encodeURIComponent(dadosConsultaPJ.endereco)}`}
            />
            <img
              className="print-only"
              style={{ width: '100%', borderRadius: '12px', display: 'none' }}
              alt={`Mapa do endereço: ${dadosConsultaPJ.endereco}`}
              src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(dadosConsultaPJ.endereco)}&zoom=15&size=600x300&markers=${encodeURIComponent(dadosConsultaPJ.endereco)}&key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0`}
            />
          </div>
        )}

        {dadosConsultaPJ.cpstatus && (
          <div
            style={{
              marginTop: '16px',
              padding: '12px 16px',
              backgroundColor: '#F0F9FF',
              border: '1px solid #BAE6FD',
              borderRadius: '8px',
              fontSize: 'small',
              color: '#0369A1',
            }}
          >
            <i className="pi pi-info-circle" style={{ marginRight: '8px' }} />
            {dadosConsultaPJ.cpstatus}
          </div>
        )}
      </div>
    );
  }

  return (
    <Panel header={t('dadosConsulta')}>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('razaoSocial')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.razaoSocial} />
          </div>
        </div>
        <div className="col">
          <div>
            <label className="label-dados">{t('nomeFantasia')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.nomeFantasia ? dadosConsultaPJ.nomeFantasia : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('documento')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.documento} />
          </div>
        </div>
        <div className="col">
          <div>
            <label className="label-dados">{t('situacao')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.situacao ? dadosConsultaPJ.situacao : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('cnae')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.cnae ? dadosConsultaPJ.cnae : 'Não Informado'} />
          </div>
        </div>
        <div className="col">
          <div>
            <label className="label-dados">{t('dataAbertura')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.dataAbertura ? dadosConsultaPJ.dataAbertura : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('fone')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.telefone ? dadosConsultaPJ.telefone : 'Não Informado'} />
          </div>
        </div>
        <div className="col">
          <div>
            <label className="label-dados">{t('email')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.email ? dadosConsultaPJ.email : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('endereco')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.endereco ? dadosConsultaPJ.endereco : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('capitalSocial')}</label>
            <Chip style={{ width: "100%" }} label={capitalSocial ? capitalSocial : 'Não Informado'} />
          </div>
        </div>
      </div>
      {dadosConsultaPJ.endereco && (
        <div className="grid" style={{ marginTop: '0.5rem' }}>
          <div className="col p-fluid">
            <label className="label-dados">Localização no Mapa</label>
            <iframe
              className="no-print"
              title="Mapa do Endereço"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '8px', marginTop: '4px' }}
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0&q=${encodeURIComponent(dadosConsultaPJ.endereco)}`}
            />
            <img
              className="print-only"
              style={{ width: '100%', borderRadius: '8px', display: 'none' }}
              alt={`Mapa do endereço: ${dadosConsultaPJ.endereco}`}
              src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(dadosConsultaPJ.endereco)}&zoom=15&size=600x300&markers=${encodeURIComponent(dadosConsultaPJ.endereco)}&key=AIzaSyAmF0F41b3t1GX-sJ0rY0q1ZbyPnKENsB0`}
            />
          </div>
        </div>
      )}
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('nire')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.nire ? dadosConsultaPJ.nire : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('tipo')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.tipo ? dadosConsultaPJ.tipo : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('naturezaJuridica')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.naturezaJuridica ? dadosConsultaPJ.naturezaJuridica : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('porte')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.porte ? dadosConsultaPJ.porte : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('colaboradores')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.quantidadeColaboradores ? dadosConsultaPJ.quantidadeColaboradores : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('filiais')}</label>
            <Chip style={{ width: "100%" }} label={dadosConsultaPJ.quantidadeFiliais ? dadosConsultaPJ.quantidadeFiliais : 'Não Informado'} />
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('cnae')} Secundário</label>
            <Chip style={{ marginLeft: '0.5rem', width: "100%" }} label={cnaeSecundario ? cnaeSecundario : 'Não Informado'} />
          </div>
        </div>
        <div className="col p-fluid flex flex-wrap">
          <div>
            <label className="label-dados">{t('filiaisRegiao')}</label>
            <Chip style={{ marginLeft: '0.5rem', width: "100%" }} label={filiais ? filiais : 'Não Informado'} />
          </div>
        </div>
      </div>
    </Panel>
  );
}
